import React from 'react';
import PageLayout from '../components/PageLayout';

const PrivacyPolicy = () => (
  <PageLayout title="Privacy Policy">
    <p><strong>Last Updated:</strong> May 29, 2026</p>
    <p>Chakna Point ("we", "our", or "us") operates the Chakna Point mobile application. This page informs you of our policies regarding the collection, use, and disclosure of personal data when you use our Service.</p>

    <h2 style={{ fontSize: 18, fontWeight: 600, marginTop: 24, marginBottom: 8, color: '#2D1A00' }}>1. Information We Collect</h2>
    <p>We collect the following types of information:</p>
    <ul style={{ paddingLeft: 20, marginTop: 8 }}>
      <li><strong>Personal Information:</strong> Name, phone number, email address (optional), delivery address.</li>
      <li><strong>Usage Data:</strong> App usage patterns, pages visited, features used, time spent on the app.</li>
      <li><strong>Device Information:</strong> Device type, operating system, unique device identifiers, IP address.</li>
      <li><strong>Location Data:</strong> With your permission, we collect location data to show nearby pickup points.</li>
      <li><strong>Payment Information:</strong> Payment method details are processed securely through third-party payment processors (Razorpay). We do not store your card details.</li>
    </ul>

    <h2 style={{ fontSize: 18, fontWeight: 600, marginTop: 24, marginBottom: 8, color: '#2D1A00' }}>2. How We Use Your Information</h2>
    <ul style={{ paddingLeft: 20 }}>
      <li>To provide and maintain our Service</li>
      <li>To process and fulfill your orders</li>
      <li>To send you order updates and notifications</li>
      <li>To provide customer support</li>
      <li>To send promotional offers and updates (with your consent)</li>
      <li>To improve our app and services</li>
      <li>To detect and prevent fraud</li>
    </ul>

    <h2 style={{ fontSize: 18, fontWeight: 600, marginTop: 24, marginBottom: 8, color: '#2D1A00' }}>3. Data Sharing</h2>
    <p>We do not sell your personal information. We may share your data with:</p>
    <ul style={{ paddingLeft: 20 }}>
      <li><strong>Service Providers:</strong> Payment processors, SMS gateways, cloud hosting providers.</li>
      <li><strong>Pickup Point Partners:</strong> Your name and order details to fulfill your order.</li>
      <li><strong>Legal Requirements:</strong> When required by law or to protect our rights.</li>
    </ul>

    <h2 style={{ fontSize: 18, fontWeight: 600, marginTop: 24, marginBottom: 8, color: '#2D1A00' }}>4. Data Security</h2>
    <p>We implement industry-standard security measures to protect your data, including encryption in transit (HTTPS/TLS), secure storage, and access controls. However, no method of transmission over the Internet is 100% secure.</p>

    <h2 style={{ fontSize: 18, fontWeight: 600, marginTop: 24, marginBottom: 8, color: '#2D1A00' }}>5. Data Retention</h2>
    <p>We retain your personal data only for as long as necessary to provide our services and fulfill the purposes outlined in this policy. You can request deletion of your account and data at any time.</p>

    <h2 style={{ fontSize: 18, fontWeight: 600, marginTop: 24, marginBottom: 8, color: '#2D1A00' }}>6. Your Rights</h2>
    <ul style={{ paddingLeft: 20 }}>
      <li>Access your personal data</li>
      <li>Correct inaccurate data</li>
      <li>Request deletion of your data</li>
      <li>Opt-out of marketing communications</li>
      <li>Withdraw consent for data processing</li>
    </ul>

    <h2 style={{ fontSize: 18, fontWeight: 600, marginTop: 24, marginBottom: 8, color: '#2D1A00' }}>7. Third-Party Services</h2>
    <p>Our app uses the following third-party services that may collect data:</p>
    <ul style={{ paddingLeft: 20 }}>
      <li>Firebase (Authentication, Analytics, Cloud Messaging)</li>
      <li>Razorpay (Payment Processing)</li>
      <li>Cloudinary (Image Storage)</li>
    </ul>

    <h2 style={{ fontSize: 18, fontWeight: 600, marginTop: 24, marginBottom: 8, color: '#2D1A00' }}>8. Children's Privacy</h2>
    <p>Our Service is not intended for use by anyone under the age of 18. We do not knowingly collect personal information from children under 18.</p>

    <h2 style={{ fontSize: 18, fontWeight: 600, marginTop: 24, marginBottom: 8, color: '#2D1A00' }}>9. Changes to This Policy</h2>
    <p>We may update this Privacy Policy from time to time. We will notify you of any changes by posting the new policy on this page and updating the "Last Updated" date.</p>

    <h2 style={{ fontSize: 18, fontWeight: 600, marginTop: 24, marginBottom: 8, color: '#2D1A00' }}>10. Contact Us</h2>
    <p>If you have questions about this Privacy Policy, please contact us at:</p>
    <p><strong>Email:</strong> support@chaknapoint.com<br /><strong>Phone:</strong> +91 98765 43210</p>
  </PageLayout>
);

export default PrivacyPolicy;
